import React from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { useI18n } from "../contexts/I18nContext";
import { PRIVACY_POLICY_URL } from "../lib/legalLinks";
import { SEO_NAV } from "../lib/seoPages";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer style={{ background: "#0c0018", borderTop: "1px solid rgba(255,255,255,0.06)", padding: "40px 16px 24px", marginTop: "60px", color: "rgba(255,255,255,0.55)" }}>
      <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "30px", marginBottom: "30px" }}>
          <div>
            <div className="font-cinzel" style={{ color: "#FFD166", fontSize: "1.1rem", marginBottom: "10px" }}>AstroFate</div>
            <p style={{ fontSize: "0.82rem", lineHeight: 1.7, color: "rgba(255,255,255,0.45)" }}>
              {t("footer.tagline")}
            </p>
          </div>

          <div>
            <div style={{ color: "#fff", fontSize: "0.85rem", fontWeight: "600", marginBottom: "10px" }}>{t("footer.quickLinks")}</div>
            <ul style={{ listStyle: "none", padding: 0, lineHeight: 2 }}>
              <li><Link data-testid="footer-link-home" to="/" style={{ color: "rgba(255,255,255,0.55)", textDecoration: "none", fontSize: "0.85rem" }}>{t("footer.home")}</Link></li>
              <li><Link data-testid="footer-link-chat" to="/chat" style={{ color: "rgba(255,255,255,0.55)", textDecoration: "none", fontSize: "0.85rem" }}>{t("footer.aiChat")}</Link></li>
              <li><Link data-testid="footer-link-consult" to="/consultation" style={{ color: "rgba(255,255,255,0.55)", textDecoration: "none", fontSize: "0.85rem" }}>{t("footer.bookConsult")}</Link></li>
              <li><Link data-testid="footer-link-blog" to="/blog" style={{ color: "rgba(255,255,255,0.55)", textDecoration: "none", fontSize: "0.85rem" }}>{t("footer.blog")}</Link></li>
              <li><Link data-testid="footer-link-dashboard" to="/dashboard" style={{ color: "rgba(255,255,255,0.55)", textDecoration: "none", fontSize: "0.85rem" }}>{t("footer.dashboard")}</Link></li>
            </ul>
          </div>

          <div>
            <div style={{ color: "#fff", fontSize: "0.85rem", fontWeight: "600", marginBottom: "10px" }}>Free astrology guides</div>
            <ul style={{ listStyle: "none", padding: 0, lineHeight: 2 }}>
              {SEO_NAV.map(([href, label]) => (
                <li key={href}>
                  <Link data-testid={`footer-link-${href.slice(1)}`} to={href} style={{ color: "rgba(255,255,255,0.55)", textDecoration: "none", fontSize: "0.85rem" }}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div style={{ color: "#fff", fontSize: "0.85rem", fontWeight: "600", marginBottom: "10px" }}>{t("footer.policies")}</div>
            <ul style={{ listStyle: "none", padding: 0, lineHeight: 2 }}>
              <li><Link data-testid="footer-link-contact" to="/contact" style={{ color: "rgba(255,255,255,0.55)", textDecoration: "none", fontSize: "0.85rem" }}>{t("footer.contact")}</Link></li>
              <li><Link data-testid="footer-link-privacy" to={PRIVACY_POLICY_URL} style={{ color: "rgba(255,255,255,0.55)", textDecoration: "none", fontSize: "0.85rem" }}>Privacy Policy</Link></li>
              <li><Link data-testid="footer-link-terms" to="/terms" style={{ color: "rgba(255,255,255,0.55)", textDecoration: "none", fontSize: "0.85rem" }}>{t("footer.terms")}</Link></li>
              <li><Link data-testid="footer-link-refunds" to="/refunds" style={{ color: "rgba(255,255,255,0.55)", textDecoration: "none", fontSize: "0.85rem" }}>{t("footer.refunds")}</Link></li>
              <li><Link data-testid="footer-link-account-privacy" to="/account/privacy" style={{ color: "rgba(255,255,255,0.55)", textDecoration: "none", fontSize: "0.85rem" }}>Account &amp; Privacy</Link></li>
              <li><Link data-testid="footer-link-account-delete" to="/account/delete" style={{ color: "rgba(255,255,255,0.55)", textDecoration: "none", fontSize: "0.85rem" }}>Delete Account</Link></li>
            </ul>
          </div>

          <div>
            <div style={{ color: "#fff", fontSize: "0.85rem", fontWeight: "600", marginBottom: "10px" }}>{t("footer.contactHeading")}</div>
            <a href="mailto:info@theastrofate.com" style={{ display: "inline-flex", alignItems: "center", gap: "6px", color: "rgba(255,255,255,0.55)", textDecoration: "none", fontSize: "0.85rem" }}>
              <Mail size={14} /> info@theastrofate.com
            </a>
            <p style={{ marginTop: "8px", fontSize: "0.78rem", color: "rgba(255,255,255,0.4)" }}>
              <a href="https://www.theastrofate.com" target="_blank" rel="noreferrer" style={{ color: "rgba(255,255,255,0.55)", textDecoration: "none" }}>theastrofate.com</a>
            </p>
          </div>
        </div>

        <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)", paddingTop: "18px", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "10px", fontSize: "0.78rem", color: "rgba(255,255,255,0.35)" }}>
          <span>© {new Date().getFullYear()} AstroFate. {t("footer.allRights")}</span>
          <span>{t("footer.payments")}</span>
        </div>
      </div>
    </footer>
  );
}
